export const I18N_URL = process.env.VUE_APP_I18N_URL
export const MANIFEST_URL = `${I18N_URL}/manifest.json`
